import React, { useEffect, useState } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import { Popover, Typography } from "@mui/material";
import I18N from "../../../../../../Wirtschaftswunder/oc-modules/oc-I18N/I18N";
import ChangeSizeDialog from "../popovers/ChangeSizeDialog";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CustomSelect from "../CustomSelext";
import { TabsListUnstyled, TabsUnstyled, TabUnstyled, tabUnstyledClasses } from "@mui/base";
import styled from "@emotion/styled";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router";

const TabsList = styled(TabsListUnstyled)`
  white-space: nowrap;
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  padding-top: 12px;
  padding-bottom: 4px;
  margin-bottom: -8px;
  box-sizing: content-box;
`;

const Tab = styled(TabUnstyled)`
  background-color: #fff;
  color: #939599;
  padding: 6px 12px;
  outline: none;
  border-width: 0 0 2px 0;
  border-bottom-color: transparent;
  border-style: solid;
  box-shadow: none;
  font-size: 18px;

  &:first-of-type {
    margin-left: 50px;
  }

  &:last-of-type {
    margin-right: 50px;
  }

  &:hover {
    border-bottom-color: #c91113;
    color: #3a415a;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: #fff;
    color: #3a415a;
    border-bottom-color: #c91113;
  }

  &:not(:last-of-type)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 2px;
    bottom: 2px;
    width: 1px;
    height: 100%;
    background-color: #e5e5e5;
  }
`;

export default function Booth(props) {
  const theme = useTheme();
  const params = useParams();

  // const selectedComb = APP.arrangement?.state?.selectedComb;

  // const sizes = _.uniq(booth?.FormsForBooths?.map((ffb) => ffb.Size));
  // debugger;
  // const [size, setSize] = useState(selectedComb);
  const [tab, setTab] = useState(window.innerWidth > 1200 ? false : 1);
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // let oldSize = "";

  // debugger;

  // const smallestSize = props.booth?.FormsForBooths?.map(ffb => ffb.Size)?.sort((a,b)=>a.Name.localeCompare(b.Name))[0].Name;
  // const sizes = _.uniq(props.booth?.FormsForBooths?.map((ffb) => ffb.Size));
  // const [size, setSize] = useState(props.booth?.selectedSize || smallestSize);
  // useEffect(() => {
  //   if (!size) {
  //     setSize(props.booth?.selectedSize || smallestSize);
  //   }
  // }, [props.booth?.selectedSize, smallestSize]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const handleWindowSizeChange = () => {
    setTab(window.innerWidth > 1200 ? false : 1);
  };

  const booth = APP.arrangement?.state?.booth;
  const { selectedComb, selectedColors } = APP.arrangement ? APP.arrangement?.state : {};

  const selectedSize = selectedComb?.Size;
  const selectedForm = selectedComb?.Form;
  const sizes = _.uniq(booth?.FormsForBooths?.map((ffb) => ffb.Size));
  const forms = (booth ? booth.FormsForBooths?.filter((ffb) => ffb.Size == selectedSize) : []).map(
    (f) => f?.Form
  );

  // if (selectedComb) debugger;
  // const [size, setSize] = useState(selectedComb);

  // if (selectedForm) debugger;

  // const formsForBooths = booth ? booth.FormsForBooths?.filter((ffb) => ffb.Size.Name == size) : [];

  const colorSetsForForm = selectedComb?.Form?.ColorSetsForForms;

  // Ich brauche ein size dropdown
  // Alles sizes + eine size

  // Ich brauche ein Type Select
  // Alle Types + ein select

  const changeComb = (form) => {
    const comb = booth.FormsForBooths?.filter((ffb) => ffb.Size == selectedSize).find(
      (fcomb) => fcomb.Form == form
    );
    APP.arrangement.setSelectedComb(comb);
  };

  const setBoothSize = (size) => {
    const change = () => {
      const comb = booth.FormsForBooths.find((ffb) => ffb.Size.Name === size);
      APP.arrangement.setSelectedComb(comb);
    };

    if (APP.arrangement.booth.interiors.length > 0) {
      APP.arrangement.setPopover({
        positionX: window.innerWidth / 2,
        positionY: window.innerHeight / 2,
        content: ChangeSizeDialog({
          onSuccess: () => {
            change();
            APP.arrangement.clearBooth();
            APP.arrangement.setPopover(undefined);
          },
          onDecline: () => {
            APP.arrangement.setPopover(undefined);
          },
        }),
      });
    } else {
      change();
    }

    // maybeShowInteriorChangeDialog();
  };

  const maybeShowInteriorChangeDialog = () => {
    if (APP.arrangement.booth.interiors.length > 0) {
      APP.arrangement.setPopover({
        positionX: window.innerWidth / 2,
        positionY: window.innerHeight / 2,
        content: ChangeSizeDialog(),
      });
    }
  };

  const sortColorSetsForForm = (a, b) => {
    return a.ColoringText.localeCompare(b.ColoringText);
  };

  // Popover
  const [popoverState, setPopoverState] = React.useState({
    openedPopoverId: null,
    anchorEl: null,
  });

  const handlePopoverOpen = (event, popoverId) => {
    setPopoverState({
      openedPopoverId: popoverId,
      anchorEl: event.target,
    });
  };

  const handlePopoverClose = () => {
    setPopoverState({
      openedPopoverId: null,
      anchorEl: null,
    });
  };

  return (
    <>
      {forms && (
        <>
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E5",
              [theme.breakpoints.up("lg")]: {
                display: "none",
              },
            }}
          >
            <TabsUnstyled value={tab} sx={{overflow: 'hidden'}} onChange={(e, newValue) => setTab(newValue)}>
              <TabsList>
                {sizes && <Tab value={1}>{I18N("Size")}</Tab>}
                {selectedComb && <Tab value={2}>{I18N("Form")}</Tab>}
                {colorSetsForForm &&
                  colorSetsForForm.sort(sortColorSetsForForm).map((colorSetForForm, index) => {
                    {
                      return <Tab value={3 + index}>{I18N(colorSetForForm.ColoringText)}</Tab>;
                    }
                  })}
              </TabsList>
            </TabsUnstyled>
          </Box>

          {sizes && (!tab || tab === 1) && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "0 18px 0 18px",
                flex: "1 1 auto",
                overflowY: "visible",
                minHeight: "105px",
                [theme.breakpoints.up("lg")]: {
                  overflowY: "visible",
                  height: "auto",
                  marginBottom: "28px",
                  padding: "18px 18px 0 18px",
                  minHeight: "auto",
                  flex: "none",
                },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  display: "none",
                  color: "#3A415A",
                  fontWeight: "700",
                  paddingBottom: "4px",
                  borderBottom: "1px solid #E2E2E2",
                  marginBottom: "10px",
                  [theme.breakpoints.up("lg")]: {
                    display: "block",
                  },
                }}
              >
                {I18N("Size")}
              </Typography>
              <FormControl>
                <CustomSelect
                  id="sizeSelection"
                  onChangeFn={(value) => {
                    setBoothSize(value);
                  }}
                  options={sizes.map((s) => s.Name)}
                  value={selectedSize ? selectedSize.Name : ""}
                  placement={window.innerWidth > 1200 ? "bottom" : "top"}
                  sx={{
                    width: "100%",
                    margin: "auto",
                    border: "1px solid #E5E5E5",
                    padding: "8px",
                    borderRadius: "4px",
                    "&:hover": {
                      border: "1px solid #939599",
                    },
                  }}
                />
              </FormControl>
            </Box>
          )}

          {selectedComb && (!tab || tab === 2) && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "0 0 0 18px",
                flex: "1 1 auto",
                overflowY: "auto",
                minHeight: "105px",
                [theme.breakpoints.up("lg")]: {
                  overflowY: "visible",
                  minHeight: "auto",
                  height: "auto",
                  marginBottom: "28px",
                  padding: "18px 18px 0 18px",
                  flex: "none",
                },
              }}
            >
              <>
                <Typography
                  variant="h6"
                  sx={{
                    display: "none",
                    color: "#3A415A",
                    fontWeight: "700",
                    paddingBottom: "4px",
                    borderBottom: "1px solid #E2E2E2",
                    marginBottom: "10px",
                    [theme.breakpoints.up("lg")]: {
                      display: "block",
                    },
                  }}
                >
                  {I18N("Form")}
                </Typography>
                <ImageList
                  sx={{
                    marginTop: 0,
                    marginBottom: 0,
                    display: "flex !important",
                    [theme.breakpoints.up("lg")]: {
                      display: "grid !important",
                    },
                  }}
                  cols={5}
                  gap={5}
                >
                  {forms.map((comb) => {
                    // debugger;
                    return (
                      <>
                        <ImageListItem
                          onClick={() => changeComb(comb)}
                          onMouseEnter={(e) => handlePopoverOpen(e, comb.id)}
                          onMouseLeave={(e) => handlePopoverClose(e, comb.id)}
                          key={"booth/" + comb.id}
                          sx={{
                            border: "2px solid transparent",
                            borderColor: (theme) =>
                              selectedForm == comb
                                ? theme.palette.primary.main
                                : `rgb(240, 240, 240)`,
                            ":hover": {
                              borderColor: (theme) => theme.palette.primary.main,
                              cursor: "pointer",
                            },
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "4px",
                            padding: "8px",
                            width: "56px",
                            height: "56px",
                            backgroundColor: "#F5F6FA",
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.1)",
                            },
                          }}
                        >
                          {comb.Thumbnail && (
                            <>
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  style={{
                                    height: "31px !important",
                                    width: "31px",
                                    userSelect: "none",
                                    borderRadius: "2px",
                                  }}
                                  src={`${comb.Thumbnail}`}
                                  srcSet={`${comb.Thumbnail}`}
                                  alt={comb.Name}
                                  loading="lazy"
                                  draggable={false}
                                />
                              </Box>
                              <Popover
                                id="mouse-over-popover"
                                sx={{
                                  pointerEvents: "none",
                                  borderRadius: "10px",
                                  top: "-45px !important",
                                }}
                                open={popoverState.openedPopoverId === comb.id}
                                anchorEl={popoverState.anchorEl}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                              >
                                <Box
                                  sx={{
                                    backgroundColor: "rgba(14, 14, 44, 0.4)",
                                    color: "#fff",
                                    padding: "0 10px",
                                  }}
                                >
                                  <Typography sx={{ p: 1 }}>{comb.Label}</Typography>
                                </Box>
                              </Popover>
                            </>
                          )}
                        </ImageListItem>
                      </>
                    );
                  })}
                </ImageList>
              </>
            </Box>
          )}

          {colorSetsForForm &&
            colorSetsForForm.sort(sortColorSetsForForm).map((colorSetForForm, index) => {
              const defaultSelectedColor = selectedColors.find(
                (sC) => sC.colorPrefix == colorSetForForm.MaterialPrefix
              );
              return (
                <>
                  {(!tab || tab === 3 + index) && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        padding: "0 0 0 18px",
                        flex: "1 1 auto",
                        overflowY: "auto",
                        minHeight: "105px",
                        [theme.breakpoints.up("lg")]: {
                          overflowY: "visible",
                          height: "auto",
                          marginBottom: "28px",
                          padding: "18px 18px 0 18px",
                          minHeight: "auto",
                          flex: "none",
                        },
                      }}
                    >
                      <div key={`colorSet/${colorSetForForm.id}`}>
                        <>
                          <Typography
                            variant="h6"
                            sx={{
                              display: "none",
                              color: "#3A415A",
                              fontWeight: "700",
                              paddingBottom: "4px",
                              borderBottom: "1px solid #E2E2E2",
                              marginBottom: "10px",
                              [theme.breakpoints.up("lg")]: {
                                display: "block",
                              },
                            }}
                          >
                            {I18N(colorSetForForm.ColoringText)}
                          </Typography>
                          <ImageList
                            sx={{
                              marginTop: "1em",
                              overflowY: "visible",
                              display: "flex",
                              flexDirection: "row",
                              gap: "12px",
                              [theme.breakpoints.up("lg")]: {
                                display: "grid",
                                flexDirection: "unset",
                                gap: "12px 0px !important",
                              },
                            }}
                            cols={5}
                          >
                            {colorSetForForm.ColorSet.ColorForColorSet.map((color) => {
                              // const selectedColorForThisColorSet = selectedColors.find(sC => sC.colorPrefix == color.)
                              return (
                                <ImageListItem
                                  onClick={() => {
                                    console.log();
                                    const newSelectedColors = [
                                      ...selectedColors.filter(
                                        (sC) => sC.colorPrefix !== colorSetForForm.MaterialPrefix
                                      ),
                                      {
                                        colorPrefix: colorSetForForm.MaterialPrefix,
                                        colorId: color.id,
                                        color: color.Color,
                                        articleId: color.Article.Artikelnummer,
                                      },
                                    ];
                                    APP.arrangement.setSelectedColors(newSelectedColors);
                                  }}
                                  key={`colorselector/${colorSetForForm.id}/${color.id}`}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      backgroundColor: `#${color.Color.getHexString()}`,
                                      borderRadius: "50%",
                                      width: "43px",
                                      height: "43px",
                                      border: "2px solid transparent",
                                      boxShadow: "inset 4px 2px 4px rgba(0, 0, 0, 0.1)",
                                      padding: "2px",
                                      borderColor: (theme) =>
                                        defaultSelectedColor.colorId === color.id
                                          ? theme.palette.primary.main
                                          : `rgb(240, 240, 240)`,
                                      ":hover": {
                                        borderColor: (theme) => theme.palette.primary.main,
                                        cursor: "pointer",
                                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                                      },
                                    }}
                                  >
                                    {defaultSelectedColor.colorId === color.id && (
                                      <IconButton
                                        color="white"
                                        sx={{
                                          boxShadow: 0,
                                        }}
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                    )}
                                  </Box>
                                </ImageListItem>
                              );
                            })}
                          </ImageList>
                        </>
                      </div>
                    </Box>
                  )}
                </>
              );
            })}
        </>
      )}
    </>
  );
}
